import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function GasIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18061_10602)">
          <path
            d="M16.25 11.25C16.25 5.625 10 1.875 10 1.875C10 1.875 3.75 5.625 3.75 11.25C3.75 12.9076 4.40848 14.4973 5.58058 15.6694C6.75269 16.8415 8.3424 17.5 10 17.5C11.6576 17.5 13.2473 16.8415 14.4194 15.6694C15.5915 14.4973 16.25 12.9076 16.25 11.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.875 14.375C6.875 15.2038 7.20424 15.9987 7.79029 16.5847C8.37634 17.1708 9.1712 17.5 10 17.5C10.8288 17.5 11.6237 17.1708 12.2097 16.5847C12.7958 15.9987 13.125 15.2038 13.125 14.375C13.125 11.25 10 9.375 10 9.375C10 9.375 6.875 11.25 6.875 14.375Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18061_10602">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
